module.exports = __webpack_public_path__ + "img/Villa_Borna_24.738f116b.jpg";